import store from "@/store/index";

export function translate(item: any) {
  switch (store.state.Locale) {
    case "en":
      return item.enName;
    case "zh-TW":
      return item.zhName;
    default:
      return "";
  }
}

export function phaseTranslate(item: number) {
  const local = store.state.Locale;
  switch (item) {
    case 1:
      if (local === "en") {
        return "Draft";
      } else if (local === "zh-TW") {
        return "起草階段";
      }
      break;
    case 2:
      if (local === "en") {
        return "Initiating";
      } else if (local === "zh-TW") {
        return "初始階段";
      }
      break;
    case 3:
      if (local === "en") {
        return "Planning";
      } else if (local === "zh-TW") {
        return "計畫階段";
      }
      break;
    case 4:
      if (local === "en") {
        return "Executing";
      } else if (local === "zh-TW") {
        return "執行階段";
      }
      break;
    case 5:
      if (local === "en") {
        return "Closing";
      } else if (local === "zh-TW") {
        return "結束階段";
      }
      break;
    case 6:
      if (local === "en") {
        return "Closed";
      } else if (local === "zh-TW") {
        return "已結案";
      }
      break;
  }
}

export function statusTranslate(item: number) {
  const local = store.state.Locale;
  switch (item) {
    case 1:
      if (local === "en") {
        return "Ongoing";
      } else if (local === "zh-TW") {
        return "進行中";
      }
      break;
    case 2:
      if (local === "en") {
        return "Completed";
      } else if (local === "zh-TW") {
        return "已完成";
      }
      break;
    case 3:
      if (local === "en") {
        return "Terminated";
      } else if (local === "zh-TW") {
        return "已終止";
      }
      break;
    case 4:
      if (local === "en") {
        return "Under Termination";
      } else if (local === "zh-TW") {
        return "終止中";
      }
      break;
    case 5:
      if (local === "en") {
        return "Under Project Change";
      } else if (local === "zh-TW") {
        return "變更中";
      }
      break;
  }
}
